import { graphql } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as React from 'react'
import ReactMarkdown from 'react-markdown'
import Header from '../components/header'
import Layout from '../components/layout'
import NextPage from '../components/nextPage'
import SEO from '../components/seo'
import Spacer from '../components/spacer'
import { articleDescription, articleDate } from '../lib/articleSeo'

const Blog = ({ data: { blog, news }, location }) => {
	const { info, date, image, contentBlocks, seo, authorName, authorType, meta } = blog
	const description = seo?.description || articleDescription(contentBlocks)

	return (
		<Layout className='pth'>
			<SEO
				title={seo?.title || info}
				description={description}
				image={seo?.image?.url || image?.url}
				pathname={location.pathname}
				article={{
					headline: info,
					datePublished: articleDate(date),
					dateModified: meta?.updatedAt,
					image: image?.url,
					author: authorName ? { '@type': authorType || 'Organization', name: authorName } : undefined,
				}}
			/>
			<Header page='News' />

			<div className='flex flex-column pl40 pr40 pt80 pb40 m-p20'>
				<div className=' flex flex-col ma'>
					<Spacer className='m-hide' />
					<p className='text-center m-mt40 op-50 mb20 max-650 ma'>{date}</p>
					<h1 className='h1 mb40 small max-650 ma'>{info}</h1>

					{image?.gatsbyImageData && (
						<div className='mb40 max-900 ma'>
							<GatsbyImage image={image.gatsbyImageData} alt={image.alt || info || date} className='w-100' />
						</div>
					)}

					<div className='content-blocks mt20 flex flex-col gap-40'>
						{contentBlocks?.map((block, index) => {
							if (block.__typename === 'DatoCmsImage' && block.image?.gatsbyImageData) {
								return (
									<div key={block.id || index} className='mb20 max-650 w-100 ma'>
										<GatsbyImage image={block.image.gatsbyImageData} alt={block.image.alt || info || date} className='w-100 ' />
									</div>
								)
							}

							if (block.__typename === 'DatoCmsContent' && block.content) {
								return <ReactMarkdown key={block.id || index} className='flex flex-col gap-20 max-650 w-100 ma content-block' children={block.content} />
							}

							return null
						})}
						<ShareButton />
					</div>
				</div>
			</div>

			<Spacer />

			<div className='pt40 pb80'>
				<NextPage overline='Go back' title='News & Articles' link='/news' image={news?.image} />
			</div>
		</Layout>
	)
}

export default Blog

const ShareButton = () => {
	const [copied, setCopied] = React.useState(false)

	const handleCopy = () => {
		navigator.clipboard.writeText(window.location.href)
		setCopied(true)
		setTimeout(() => setCopied(false), 2000)
	}

	return (
		<button className='button h3 max-650 ma' onClick={handleCopy}>
			{copied ? 'Copied!' : 'Share Article'}
		</button>
	)
}

export const query = graphql`
	query BlogPostBySlug($id: String!) {
		news: datoCmsNews {
			image {
				gatsbyImageData
				alt
			}
		}
		blog: datoCmsBlog(id: { eq: $id }) {
			id
			date
			info
			slug
			authorName
			authorType
			meta {
				updatedAt
			}
			seo {
				title
				description
				image { url }
			}
			image {
				url
				gatsbyImageData
				alt
			}
			contentBlocks {
				... on DatoCmsImage {
					id
					__typename
					image {
						gatsbyImageData
						alt
					}
				}
				... on DatoCmsContent {
					id
					__typename
					content
				}
			}
		}
	}
`
